const barbaAfterFunctions = (pageData) => {
  
  /***************************************************************
    FILTER THROUGH ALL SCRIPTS IN HEAD AND BODY AND RERUN THEM
  ***************************************************************/

  let js = $(pageData.next.html).filter('script');

  js.each((function() {

    let $src = $(this).attr('src');

    if (typeof $src !== 'undefined' && $src !== false && $src.indexOf('scripts.js') === -1 && $src.indexOf('code.jquery') === -1 && $src.indexOf('script.crazyegg.com/pages/scripts/') === -1 && $src.indexOf('gravityforms/') === -1) {
      $.getScript($src, function() {
        console.log('loaded');
      });
    }

  }));
	
	/***************************************************************
		Unhover nav dropdown on click
	***************************************************************/
	
	const $subMenu = $('nav .sub-menu');
	
	$subMenu.attr('style', '');

	//const $topLinks = $('.menu > .menu-item');
	//const $subLinks = $('.submenu-item a');

	//$subLinks.on('click', function() {
	//	console.log('click');
	//});

    
}

export {
  barbaAfterFunctions
};
